import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//默认购买数量处理
export function defaultBuyNum(datas) {
  datas.forEach(function (v) {
    if (v.activityVOList && v.activityVOList.length) {
      // type 为3时，说明是特价品种
      var activityIndex = v.activityVOList.findIndex(function (item) {
        return item.type == 3;
      });
      // 过虑出特价品种数据
      var activityGoodArr = v.activityVOList.filter(function (item) {
        return item.type == 3;
      });
      // 判断是否是特价品种
      v.isActivityGood = activityIndex !== -1;
      // 添加特价品种数据
      v.activityGoodInfo = activityGoodArr[0] || {};
    } else {
      v.isActivityGood = false;
      v.activityGoodInfo = {};
    }
  });
  return datas;
}

// 默认购买数量处理
export function purchaseQuantityProcessing(datas) {
  if (datas.length == 0) return [];
  datas.forEach(function (v) {
    if (!v.activityVo) {
      v.activityVo = {
        hasActivity: false,
        activityStrategyReduceVOS: []
      };
    }
    v.isMediumPackage = v.isMiddlePack; // 是否是中包装
    v.mediumPackage = v.packageNumber; // 中包装数量
    v.availableNum = v.availableStock; // 可用库存

    if (v.unitPrice) {
      v.unitPrice = String(v.unitPrice.toFixed(2));
    }

    // bigPreferentialType  1.票折  2.特价  3.赠品  4.票折+红包  5.票折+特价  6.票折+赠品  7.特价+赠品

    // buyCount 推荐购买数量（取活动满足数量）  判断逻辑，满足条件类型编码(1->满量,2-> 满额)  condTypeCode = 1的，然后取满足度量condMeas
    var _v$activityVo = v.activityVo,
      hasActivity = _v$activityVo.hasActivity,
      planListVOS = _v$activityVo.planListVOS,
      activityStrategyReduceVOS = _v$activityVo.activityStrategyReduceVOS;
    // 有活动
    if (hasActivity) {
      activityStrategyReduceVOS.forEach(function (item) {
        if (item.activityPrice) item.activityPrice = item.activityPrice.toFixed(2).toString();
      });
      if (activityStrategyReduceVOS && activityStrategyReduceVOS.length) {
        // preferentialType 让利类型  (1.票折，2.红包，3.特价, 4.赠品)
        var activityIndex = activityStrategyReduceVOS.findIndex(function (item) {
          return item.preferentialType == 3;
        });
        var redAnvelopeActivityIndex = activityStrategyReduceVOS.findIndex(function (item) {
          return item.preferentialType == 2;
        });
        // 判断是否是红包活动
        v.isRedAnvelopeActivity = redAnvelopeActivityIndex !== -1;

        // 过虑出特价品种数据
        var activityGoodArr = activityStrategyReduceVOS.filter(function (item) {
          return item.preferentialType == 3;
        });
        // 判断是否是特价品种
        v.isActivityGood = activityIndex !== -1;
        // 添加特价品种数据
        v.activityGoodInfo = activityGoodArr[0] || {};
      } else {
        v.isActivityGood = false;
        v.activityGoodInfo = {};
      }

      // 有活动商品
      if (activityStrategyReduceVOS && activityStrategyReduceVOS.length > 0) {
        // 中包装
        if (v.isMiddlePack == 1) {
          v.buyCount = v.meetWithActiveNum; // 活动满足数量
          v.activityGoodInfo.activityCount = v.meetWithActiveNum; // 活动满足数量
        } else {
          v.buyCount = activityStrategyReduceVOS[0].condMeas;
          v.activityGoodInfo.activityCount = activityStrategyReduceVOS[0].condMeas;
        }
      }
    } else {
      if (v.startBuyNum) {
        // 有起售数量
        v.buyCount = v.startBuyNum;
      } else if (v.isMiddlePack == 1) {
        // 是中包装
        v.buyCount = 1;
      } else {
        // 最低限制数量
        v.buyCount = v.notLowerSale || 1;
      }
    }
  });
  return datas;
}

// 数组对象去重
export function arrUnique(arr, key) {
  var obj = {};
  var arrays = arr.reduce(function (setArr, item) {
    obj[item[key]] ? '' : obj[item[key]] = true && setArr.push(item);
    return setArr;
  }, []);
  return arrays;
}

//【获取n天前时间】: 传参数几就是今天往前推几天的日期。比如传7就是往前七天的日期
export function theOtherDay(n) {
  //开始时间
  var nowDate = new Date();
  var befDate = new Date(nowDate.getTime() - n * 24 * 3600 * 1000);
  var byear = befDate.getFullYear();
  var bmonth = befDate.getMonth() + 1;
  if (bmonth >= 1 && bmonth <= 9) {
    bmonth = "0" + bmonth;
  }
  var bday = befDate.getDate() - 1;
  if (bday >= 0 && bday <= 9) {
    bday = "0" + bday;
  }

  //截止时间
  var endDate = new Date(nowDate.getTime() - 1 * 24 * 3600 * 1000);
  var year = endDate.getFullYear();
  var month = endDate.getMonth() + 1;
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  var day = endDate.getDate() + 1;
  if (day >= 0 && day <= 9) {
    day = "0" + day;
  }

  //赋值
  var timerValue = [byear + "-" + bmonth + "-" + bday, year + "-" + month + "-" + day];
  return timerValue;
}

// url下载文件
export function urlDownloadFile(url, name) {
  fetch(url).then(function (res) {
    return res.blob();
  }).then(function (blob) {
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = name; // 下载文件的名字
    document.body.appendChild(a);
    a.click();
  });
}